// Mock Data - Bu dosyadaki verileri daha sonra güncelleyebilirsiniz

export const companyInfo = {
  name: "Kolhan Mühendislik",
  slogan: "Betonarme ve Çelik Yapı Sistem Çözümleri ve Projeleri",
  phone: "0 506 104 70 60",
  email: "info@kolhanmuhendislik.com",
  address: "Uğur Mumcu Mah. 4193 Sk. No:3 İç Kapı No:2 Karabağlar/İzmir",
  // Sosyal medya hesaplarını buradan ekleyebilirsiniz
  social: {
    instagram: "https://www.instagram.com/kolhanmuhendislik",
    linkedin: "",  // Daha sonra doldurun
    facebook: "",  // Daha sonra doldurun
  }
};

export const aboutData = {
  title: "Hakkımızda",
  description: `Kolhan Mühendislik İnşaat Sanayi ve Ticaret Ltd. Şti. olarak 2025 yılından itibaren inşaat sektöründe faaliyet göstermekteyiz. Betonarme ve çelik yapı sistem çözümleri konusunda uzmanlaşmış ekibimizle, müşterilerimize kaliteli ve güvenilir hizmet sunmaktayız.

Yapım öncesinde doğru projelendirme, detaylı araştırma ve yeni teknolojilerin takibi ile ekonomik, sürekli ve kaliteli çözümler sunuyoruz. Özellikle altyapı ve üstyapı mühendisliği gibi uzmanlık isteyen konularda deneyimli kadromuzla hizmetinizdeyiz.

Müşteri memnuniyetini ön planda tutarak, sağlam, estetik ve kullanışlı yapılar inşa etmek için çalışıyoruz.`,
  image: "https://images.unsplash.com/photo-1487491424367-7571f9afbb30"
};

export const services = [
  {
    id: 1,
    title: "Betonarme Proje",
    description: "Müşteri ihtiyaçlarını ön planda tutarak, dayanıklı ve ekonomik betonarme yapı çözümleri sunuyoruz. Detaylı statik hesaplamalar ve modern mühendislik teknikleriyle projelerinizi hayata geçiriyoruz.",
    image: "https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxjb25jcmV0ZSUyMGJ1aWxkaW5nfGVufDB8fHx8MTc2NzM0OTIwNnww&ixlib=rb-4.1.0&q=85",
    features: [
      "Statik Hesaplama ve Analiz",
      "Betonarme Taşıyıcı Sistem Tasarımı",
      "Zemin Etüdü ve Temel Tasarımı",
      "Proje Ruhsatlandırma Desteği"
    ]
  },
  {
    id: 2,
    title: "Çelik Proje",
    description: "Modern çelik konstrüksiyon sistemleriyle hızlı, esnek ve ekonomik yapı çözümleri sağlıyoruz. Endüstriyel tesislerden ticari binalara kadar geniş yelpazede çelik yapı projelerimiz bulunmaktadır.",
    image: "https://images.pexels.com/photos/257617/pexels-photo-257617.jpeg",
    features: [
      "Çelik Konstrüksiyon Tasarımı",
      "Endüstriyel Tesis Projeleri",
      "Hafif Çelik Yapı Sistemleri",
      "Çatı ve Cephe Sistemleri"
    ]
  },
  {
    id: 3,
    title: "Endüstriyel Tesis Projeleri",
    description: "Fabrika, depo ve üretim tesisleri için özel tasarlanmış çelik ve betonarme yapı çözümleri sunuyoruz. Geniş açıklıklı, fonksiyonel ve dayanıklı yapılar inşa ediyoruz.",
    image: "https://images.unsplash.com/photo-1622651351906-e6fa5f918cd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzY3MzQ5MjE3fDA&ixlib=rb-4.1.0&q=85",
    features: [
      "Fabrika ve Üretim Tesisi Projeleri",
      "Depo ve Lojistik Merkezleri",
      "Geniş Açıklıklı Yapılar",
      "Vinç Sistemleri Entegrasyonu"
    ]
  },
  {
    id: 4,
    title: "Villa Projeleri",
    description: "Modern ve estetik villa tasarımları ile hayalinizdeki yaşam alanını oluşturuyoruz. Mimari tasarım, statik hesaplama ve uygulama projelerinde profesyonel hizmet veriyoruz.",
    image: "https://images.unsplash.com/photo-1613977257365-aaae5a9817ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHx2aWxsYSUyMHBvb2x8ZW58MHx8fHwxNzY3MzQ5MjI0fDA&ixlib=rb-4.1.0&q=85",
    features: [
      "Mimari Tasarım ve Planlama",
      "Betonarme Villa Projeleri",
      "Çelik Karkas Villa Sistemleri",
      "İç Mekan Tasarımı Desteği"
    ]
  },
  {
    id: 5,
    title: "Müşavirlik ve Danışmanlık",
    description: "Deneyimli mühendislik kadromuzla projelerinizin her aşamasında yanınızdayız. Teknik danışmanlık, proje yönetimi ve kalite kontrol hizmetleriyle projelerinizi güvenle tamamlıyoruz.",
    image: "https://images.unsplash.com/photo-1557143930-d4e7a86a194f",
    features: [
      "Teknik Danışmanlık Hizmetleri",
      "Proje ve Şantiye Yönetimi",
      "Kalite Kontrol ve Denetim",
      "Ruhsatlandırma Süreç Yönetimi"
    ]
  }
];

// NOT: projects array artık veritabanından geliyor, bu yüzden buradan kaldırıldı
// Projeleri görmek için backend API'den çekiliyor: GET /api/projects

// Referans logolarını daha sonra ekleyebilirsiniz
export const references = [
  { id: 1, name: "Referans 1", logo: "" },
  { id: 2, name: "Referans 2", logo: "" },
  { id: 3, name: "Referans 3", logo: "" },
  { id: 4, name: "Referans 4", logo: "" },
  { id: 5, name: "Referans 5", logo: "" },
];

// Galeri - Proje görselleri
export const gallery = [
  {
    id: 1,
    title: "Endüstriyel Tesis İnşaatı",
    image: "https://images.unsplash.com/photo-1487491424367-7571f9afbb30",
    category: "Çelik Konstrüksiyon"
  },
  {
    id: 2,
    title: "Betonarme Yapı Detayı",
    image: "https://images.unsplash.com/photo-1613694437268-b8b2a5f98f16",
    category: "Betonarme"
  },
  {
    id: 3,
    title: "Çelik Çatı Konstrüksiyonu",
    image: "https://images.unsplash.com/photo-1609627016501-b862497c7294",
    category: "Çelik Konstrüksiyon"
  },
  {
    id: 4,
    title: "Modern İş Merkezi",
    image: "https://images.unsplash.com/photo-1704018495767-f2029b7183c5",
    category: "Betonarme"
  },
  {
    id: 5,
    title: "İnşaat Sahası",
    image: "https://images.unsplash.com/photo-1674062333283-41a1b59f0408",
    category: "Genel"
  },
  {
    id: 6,
    title: "Çelik Yapı Sistemi",
    image: "https://images.unsplash.com/photo-1557143930-d4e7a86a194f",
    category: "Çelik Konstrüksiyon"
  },
  {
    id: 7,
    title: "Depo İnşaatı",
    image: "https://images.unsplash.com/photo-1706581324170-d847716c4512",
    category: "Genel"
  },
  {
    id: 8,
    title: "Çelik Çatı Detay",
    image: "https://images.pexels.com/photos/53176/architecture-iron-steel-building-53176.jpeg",
    category: "Çelik Konstrüksiyon"
  }
];